import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 公共方法服务接口
 */
export class CommonControllerSvr {
  constructor() {
    this.baseurl = 'CommonControllerSvr.assx/';
  }

  /**
   * 保存业务单附件
   * token:String, docCode:String, importantDoc:ImportantDoc
   */
  SaveImportantDoc (token, docCode, importantDoc) {
    return request.post(this.baseurl + 'SaveImportantDoc', Qs.stringify({ token: token, docCode: docCode, importantDoc: typeof importantDoc === 'undefined' || importantDoc === null ? '' : importantDoc.toString() }));
  }
  updateValueParamByType (key,value){
    return request.post(this.baseurl + 'updateValueParamByType', Qs.stringify({key:key,value:value}) )
  }
  updateHistoryRecordsDate (keyId,flowCreateTime){
    return request.post(this.baseurl + 'updateHistoryRecordsDate', Qs.stringify({keyId:keyId,flowCreateTime:flowCreateTime}) )
  }
  updateExpertApprovalAuditDate (keyId,handleCompleteDate){
    return request.post(this.baseurl + 'updateExpertApprovalAuditDate', Qs.stringify({keyId:keyId,handleCompleteDate:handleCompleteDate}) )
  }
  /**
   * 保存业务单附件列表
   * token:String, docCode:String, importantDocs:ImportantDocList
   */
  SaveImportantDocList (token, docCode, importantDocs) {
    return request.post(this.baseurl + 'SaveImportantDocList', Qs.stringify({ token: token, docCode: docCode, importantDocs: typeof importantDocs === 'undefined' || importantDocs === null ? '' : importantDocs.toString() }));
  }

  /**
   * 根据业务单编号获取业务单运行记录
   * token:String, docCode:String, workID:String
   */
  GetRunRecordListByDocCode (token, docCode, workID) {
    return request.post(this.baseurl + 'GetRunRecordListByDocCode', Qs.stringify({ token: token, docCode: docCode, workID: workID }));
  }

  /**
   * 根据config的接点名称来获取值
   * keyNameList:String
   */
  getConfigValueHashMap (keyNameList) {
    return request.post(this.baseurl + 'getConfigValueHashMap', Qs.stringify({ keyNameList: keyNameList }));
  }

  /**
   * 根据业务单编号获取要件列表
   * token:String, docCode:String
   */
  GetImportantDocList (token, docCode) {
    return request.post(this.baseurl + 'GetImportantDocList', Qs.stringify({ token: token, docCode: docCode }));
  }

  /**
     * 电子聘书查看功能
     * token:String, expertContractNum:String, file:MemoryFile
     */
  lookElectronContract(expertContractNum,x,y){
      return request.post(this.baseurl + 'lookElectronContract', Qs.stringify({expertContractNum:expertContractNum,x:x,y:y}));
  }

  /**
   * 验证是否是市局 ,如果是，则返回区局用户的区划权限列表，不是则返回空
   * token:String
   */
  CheckIsRegionalUserAndBackCantonList (token) {
    return request.post(this.baseurl + 'CheckIsRegionalUserAndBackCantonList', Qs.stringify({ token: token }));
  }

  /**
   * 获取行政区域列表
   * token:String
   */
  getCantonList (token) {
    return request.post(this.baseurl + 'getCantonList', Qs.stringify({ token: token }));
  }

  /**
   * 发送手机验证码
   * token:String, mob:String
   */
  SendVerifyCode (token, mob) {
    return request.post(this.baseurl + 'SendVerifyCode', Qs.stringify({ token: token, mob: mob }));
  }

  /**
   * 获取下拉框中物业区域列表
   * token:String, keyWord:String, page:int, rows:int, cantonCode:String
   */
  GetEaAreaList (token, keyWord, page, rows, cantonCode) {
    return request.post(this.baseurl + 'GetEaAreaList', Qs.stringify({ token: token, keyWord: keyWord, page: page, rows: rows, cantonCode: cantonCode }));
  }

  /**
   * 根据config的接点名称来获取值
   * keyName:String
   */
  GetConfigValueList (keyName) {
    return request.post(this.baseurl + 'GetConfigValueList', Qs.stringify({ keyName: keyName }));
  }

  /**
   * 修改业务单要件
   * token:String, importantDocs:ImportantDocList
   */
  ModifyImportantDoc (token, importantDocs) {
    return request.post(this.baseurl + 'ModifyImportantDoc', Qs.stringify({ token: token, importantDocs: typeof importantDocs === 'undefined' || importantDocs === null ? '' : importantDocs.toString() }));
  }

  /**
   * 根据Config_settings中的的key获取value
   * tokens:String, keyName:String
   */
  GetSysSettingByString (tokens, keyName) {
    return request.post(this.baseurl + 'GetSysSettingByString', Qs.stringify({ tokens: tokens, keyName: keyName }));
  }

  /**
   * 清理可清理缓存列表
   * token:String
   */
  CleanRedisCache (token) {
    return request.post(this.baseurl + 'CleanRedisCache', Qs.stringify({ token: token }));
  }

  /**
   * 验证是否是市局用户
   * token:String
   */
  CheckIsCityUser (token) {
    return request.post(this.baseurl + 'CheckIsCityUser', Qs.stringify({ token: token }));
  }

  /**
   * 获取行政区域树
   * token:String, right:boolean
   */
  GetCantonTree (token, right) {
    return request.post(this.baseurl + 'GetCantonTree', Qs.stringify({ token: token, right: right }));
  }

  /**
   * 获取业务单
   * token:String, docCode:String
   */
  GetBusinessDocByDocCode (token, docCode) {
    return request.post(this.baseurl + 'GetBusinessDocByDocCode', Qs.stringify({ token: token, docCode: docCode }));
  }
  /**
   * 获取数据库枚举枚举
   * token:String, key:String, type:String
   */
  GetHouseTypeCodeListAndChild (token, key, type) {
    return request.post(this.baseurl + 'GetHouseTypeCodeListAndChild', Qs.stringify({ token: token, key: key, type: type }));
  }
  /**
   * 取房屋编码类型 列表
   * mainTypeCode:String, TypeCode:String
   */
  GetHouseTypeCodeList (mainTypeCode, TypeCode) {
    return request.post(this.baseurl + 'GetHouseTypeCodeList', Qs.stringify({ mainTypeCode: mainTypeCode, TypeCode: TypeCode }));
  }
  /**
   * 根据条件返回附件列表
   * token:String, param:AttachMentQueryPara, startIndex:int, maxSize:int
   */
  QueryAttachMentList (token, param, startIndex, maxSize) {
    return request.post(this.baseurl + 'QueryAttachMentList', Qs.stringify({ token: token, param: (typeof param === 'undefined' || param === null) ? '' : param.toString(), startIndex: startIndex, maxSize: maxSize }));
  }

  /**
     * 获取居代业管理业主共有资金基本账户备案申请表
     * token:String, docCode:String, reportName:String
     */
  getWaitingEmployApplyInfo(token, docCode, reportName){
      return request.post(this.baseurl + 'getWaitingEmployApplyInfo', Qs.stringify({ token:token, docCode:docCode, reportName:reportName }));
  }

  /**
     * 获取居代业管理业主共有资金基本账户变更备案申请表
     * token:String, docCode:String, reportName:String
     */
  getWaitingEmployChangeInfo(token, docCode, reportName){
      return request.post(this.baseurl + 'getWaitingEmployChangeInfo', Qs.stringify({ token:token, docCode:docCode, reportName:reportName }));
  }

  getSysParamValueByType(key){
    return request.post(this.baseurl + 'getSysParamValueByType', Qs.stringify({ key:key }));
  }
}